export default "__VITE_ASSET__BQW_dxiP__"